import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useSettingsStore } from '@/stores/settings'
import { translations, type TranslationKey, type Language } from './translations'

type TranslationParams = Record<string, string | number>

export function useI18n() {
  const settingsStore = useSettingsStore()
  const { language } = storeToRefs(settingsStore)
  const fallbackTranslations = translations.en as Record<string, string>
  
  // Create a function that always reads the latest language value
  function t(key: TranslationKey | string, params?: TranslationParams): string {
    const lang = language.value as Language
    const currentTranslations = translations[lang] as Record<string, string>
    const template = currentTranslations[key] ?? fallbackTranslations[key] ?? key

    if (!params) {
      return template
    }

    return Object.entries(params).reduce((result, [paramKey, value]) => {
      return result.split(`{${paramKey}}`).join(String(value))
    }, template)
  }
  
  return {
    t,
    language,
    // Also expose current language for debugging
    getCurrentLanguage: () => language.value
  }
}
